import { Typography, TypographyProps } from "@mui/material";
import type { SystemProps } from "@mui/system";
import type { Theme } from "@mui/material/styles";
import { ReactNode } from "react";
import { DEFAULT_FONTSIZE, DEFAULT_TEXT_FONT_WEIGHT } from "@/utils/utils";
import { CHART_TYPOGRAPHY } from "@/components/app/provider/patient/chart";
import { mergeSx, splitSystemProps } from "@/utils/system-props";

type TextProps = {
  children: ReactNode;
  w?: string | number;
  c?: string;
  size?: string | number;
  isTabletext?: boolean;
  fontWeight?: SystemProps<Theme>["fontWeight"];
  lineHeight?: SystemProps<Theme>["lineHeight"];
} & TypographyProps &
  SystemProps<Theme>;

const Text = ({
  w,
  c,
  size = DEFAULT_FONTSIZE.fontSize,
  isTabletext,
  variant,
  fontWeight,
  lineHeight: _lineHeight,
  children,
  sx,
  ...others
}: TextProps) => {
  const { systemSx, rest } = splitSystemProps(
    c !== undefined ? { ...others, color: c } : others
  );
  return (
    <Typography
      variant={variant}
      {...rest}
      sx={mergeSx(
        {
          width: w,
          fontSize: isTabletext ? CHART_TYPOGRAPHY.body5.fontSize : size,
          fontWeight: fontWeight ?? DEFAULT_TEXT_FONT_WEIGHT,
          textTransform: "none",
          // Spread last so caller style props (fontSize, width, …) override these defaults.
          ...systemSx,
        },
        sx
      )}
    >
      {children}
    </Typography>
  );
};

export default Text;
